import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "d-flex flex-column text-center" },
    [
      _c(
        "div",
        {
          staticClass: "mt-2",
          staticStyle: { zindex: "10", "min-height": "350px" },
        },
        [
          _c(
            "div",
            { staticClass: "mt-6" },
            [
              _c(
                VForm,
                {
                  model: {
                    value: _vm.validGrossWeight,
                    callback: function ($$v) {
                      _vm.validGrossWeight = $$v
                    },
                    expression: "validGrossWeight",
                  },
                },
                [
                  _c("div", { staticClass: "mb-5" }, [
                    _c(
                      "div",
                      { staticClass: "text-overline font-weight-light" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.currentEntry.id
                                ? _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.editEntry"
                                  )
                                : _vm.$vuetify.lang.t("$vuetify.base.entry")
                            ) +
                            " " +
                            _vm._s(_vm.currentEntryIndex) +
                            " "
                        ),
                      ]
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-center" },
                    [
                      _vm.worksheetTypeFields.hasInventorySelection
                        ? _c(
                            "div",
                            [
                              _vm.selectedInventory
                                ? _c(
                                    VBtn,
                                    {
                                      staticClass: "mr-5 my-2",
                                      attrs: {
                                        title: `Selected inventory: ${_vm.selectedInventoryLabel}`,
                                        icon: "",
                                      },
                                      on: {
                                        click: function ($event) {
                                          _vm.showInventoryDetails = true
                                        },
                                      },
                                    },
                                    [
                                      _c(VIcon, [
                                        _vm._v("mdi-information-outline"),
                                      ]),
                                    ],
                                    1
                                  )
                                : _c("div", {
                                    staticStyle: { "min-width": "36px" },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(VTextField, {
                        ref: "inputField",
                        staticStyle: {
                          "font-size": "26px",
                          "min-width": "200px",
                          "max-width": "320px",
                        },
                        attrs: {
                          outlined: "",
                          label: _vm.$vuetify.lang.t(
                            "$vuetify.base.grossWeight"
                          ),
                          type: "number",
                          inputmode: "decimal",
                          min: _vm.worksheet.deductibleWeight,
                          disabled: _vm.loading || _vm.submitted,
                          readonly: _vm.selectedInventoryUnit,
                          rules: [_vm.minWeightRule],
                          hint: _vm.ocrLoading
                            ? _vm.$vuetify.lang.t(
                                "$vuetify.worksheet.readingScale"
                              )
                            : _vm.selectedInventoryHint,
                          "persistent-hint": _vm.ocrLoading,
                          "validate-on-blur": false,
                          autofocus: "",
                        },
                        scopedSlots: _vm._u(
                          [
                            _vm.worksheetTypeFields.hasEntryPhoto
                              ? {
                                  key: "prepend-inner",
                                  fn: function () {
                                    return [
                                      _c(
                                        VBtn,
                                        {
                                          staticClass: "mt-n1",
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            title: _vm.canScanLotQr
                                              ? _vm.$vuetify.lang.t(
                                                  "$vuetify.worksheet.scanScaleOrLotQr"
                                                )
                                              : _vm.$vuetify.lang.t(
                                                  "$vuetify.worksheet.scanScale"
                                                ),
                                            disabled:
                                              _vm.loading ||
                                              _vm.submitted ||
                                              _vm.selectedInventoryUnit,
                                          },
                                          on: { click: _vm.openScaleCamera },
                                        },
                                        [
                                          _vm.ocrLoading
                                            ? _c(VProgressCircular, {
                                                attrs: {
                                                  indeterminate: "",
                                                  size: "20",
                                                  width: "2",
                                                  color: "primary",
                                                },
                                              })
                                            : _c(VIcon, [
                                                _vm._v("mdi-camera"),
                                              ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              : null,
                            {
                              key: "append",
                              fn: function () {
                                return [
                                  _vm.productInfo &&
                                  (_vm.currentEntry.grossWeight === null ||
                                    _vm.currentEntry.grossWeight === "" ||
                                    _vm.currentEntry.grossWeight === undefined)
                                    ? _c(
                                        "span",
                                        { staticClass: "mr-2 text--secondary" },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.productInfo.measureType ==
                                                  "Unit"
                                                  ? `${_vm.productInfo.measureWeight}/${_vm.productInfo.measureUnit}`
                                                  : _vm.productInfo
                                                      .measureWeight
                                              ) +
                                              " "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          true
                        ),
                        model: {
                          value: _vm.currentEntry.grossWeight,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.currentEntry,
                              "grossWeight",
                              _vm._n($$v)
                            )
                          },
                          expression: "currentEntry.grossWeight",
                        },
                      }),
                      _c(VFileInput, {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: false,
                            expression: "false",
                          },
                        ],
                        ref: "scaleCamera",
                        attrs: { capture: "environment", accept: "image/*" },
                        on: { change: _vm.onScaleCameraCapture },
                        model: {
                          value: _vm.scaleCameraFile,
                          callback: function ($$v) {
                            _vm.scaleCameraFile = $$v
                          },
                          expression: "scaleCameraFile",
                        },
                      }),
                      _c("div", {
                        staticStyle: { display: "none" },
                        attrs: { id: _vm.qrFileScannerId },
                      }),
                      _vm.canSelectInventory
                        ? _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _vm.worksheet.productId ||
                              (_vm.worksheet.products &&
                                _vm.worksheet.products.length > 0)
                                ? _c(
                                    VBtn,
                                    {
                                      staticClass: "ml-5 my-2",
                                      attrs: { icon: "" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.openInventorySelection()
                                        },
                                      },
                                    },
                                    [_c(VIcon, [_vm._v("mdi-magnify")])],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "mt-2 ml-2" },
                                [
                                  _c("qr-scanner", {
                                    attrs: { manualProcess: true },
                                    on: {
                                      captured: _vm.processScannedInventory,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _vm.hasDeductibleWeight
                ? _c(
                    "div",
                    {
                      staticClass: "text-subtitle-2 mt-4 d-flex justify-center",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column flex-sm-row justify-center",
                        },
                        [
                          _c("span", { staticClass: "mx-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$vuetify.lang.t(
                                  "$vuetify.base.deductibleWeight"
                                )
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatNumber")(
                                  _vm.worksheet.deductibleWeight
                                )
                              ) +
                                " " +
                                _vm._s(
                                  _vm.productInfo
                                    ? _vm.productInfo.measureWeight
                                    : ""
                                )
                            ),
                          ]),
                        ]
                      ),
                      _c(VDivider, {
                        staticClass: "mx-4",
                        attrs: { vertical: "" },
                      }),
                      _c(
                        "div",
                        {
                          staticClass:
                            "d-flex flex-column flex-sm-row justify-center",
                        },
                        [
                          _c("span", { staticClass: "mx-2" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$vuetify.lang.t("$vuetify.base.netWeight")
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("formatNumber")(_vm.netWeight)) +
                                " " +
                                _vm._s(
                                  _vm.productInfo
                                    ? _vm.productInfo.measureWeight
                                    : ""
                                )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              class: `d-flex ${_vm.entryIconsLayout} justify-center`,
              staticStyle: { "min-height": "130px" },
            },
            [
              _vm.worksheetTypeFields.hasEntryNotes
                ? _c(
                    "div",
                    { staticClass: "d-flex justify-center mt-4 mx-2" },
                    [
                      _c(
                        VBtn,
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showEntryNotes,
                              expression: "!showEntryNotes",
                            },
                          ],
                          attrs: { icon: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              _vm.showEntryNotes = !_vm.showEntryNotes
                            },
                          },
                        },
                        [
                          _c(VIcon, { attrs: { "x-large": "" } }, [
                            _vm._v("mdi-note-edit"),
                          ]),
                        ],
                        1
                      ),
                      _c(VExpandXTransition, [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.showEntryNotes,
                                expression: "showEntryNotes",
                              },
                            ],
                          },
                          [
                            _c(VTextarea, {
                              staticStyle: { "min-width": "300px" },
                              attrs: {
                                "append-icon": "mdi-close",
                                label: _vm.$vuetify.lang.t(
                                  "$vuetify.base.notes"
                                ),
                                disabled: _vm.loading || _vm.submitted,
                                "hide-details": "",
                                rows: 3,
                                outlined: "",
                              },
                              on: {
                                "click:append": function ($event) {
                                  _vm.showEntryNotes = false
                                },
                              },
                              model: {
                                value: _vm.currentEntry.notes,
                                callback: function ($$v) {
                                  _vm.$set(_vm.currentEntry, "notes", $$v)
                                },
                                expression: "currentEntry.notes",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                      _vm.currentEntry.notes && !_vm.showEntryNotes
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "font-weight-light text-subtitle-2 mx-2",
                              staticStyle: { "white-space": "pre" },
                            },
                            [_vm._v(" " + _vm._s(_vm.currentEntry.notes) + " ")]
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "d-flex justify-center" },
                [
                  _vm.worksheetTypeFields.hasEntryPhoto
                    ? _c("image-upload", {
                        key: `${_vm.currentEntry.id}-${_vm.addTime}`,
                        ref: "imageUpload",
                        staticClass: "mt-4 mx-2",
                        attrs: {
                          loading: _vm.loading,
                          disabled: _vm.loading || _vm.submitted,
                        },
                        model: {
                          value: _vm.currentEntry.files,
                          callback: function ($$v) {
                            _vm.$set(_vm.currentEntry, "files", $$v)
                          },
                          expression: "currentEntry.files",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
          _c(
            "div",
            { staticClass: "mt-5" },
            [
              _c(
                VBtn,
                {
                  attrs: {
                    loading: _vm.loading,
                    disabled:
                      _vm.submitted || !_vm.validGrossWeight || _vm.ocrLoading,
                    color: "primary",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.saveWorksheetEntry(
                        _vm.worksheet,
                        _vm.currentEntry
                      )
                    },
                  },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.currentEntry.id
                          ? _vm.$vuetify.lang.t("$vuetify.base.update")
                          : _vm.$vuetify.lang.t("$vuetify.base.add")
                      ) +
                      " "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1000" },
          attrs: { fullscreen: _vm.$vuetify.breakpoint.xsOnly },
          model: {
            value: _vm.inventoryLookupDialog,
            callback: function ($$v) {
              _vm.inventoryLookupDialog = $$v
            },
            expression: "inventoryLookupDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    VBtn,
                    {
                      attrs: { icon: "" },
                      on: {
                        click: function ($event) {
                          _vm.inventoryLookupDialog = false
                        },
                      },
                    },
                    [_c(VIcon, [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c(
                VCardText,
                { staticClass: "px-4 px-sm-6 px-md-8" },
                [
                  _c("inventory-selection-by-product", {
                    key: _vm.timestamp,
                    attrs: {
                      productId: _vm.worksheet.productId,
                      products: _vm.worksheet.products,
                      worksheetId: _vm.worksheet.id,
                    },
                    on: { change: _vm.inventoryChanged },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          staticStyle: { "z-index": "1001" },
          attrs: { persistent: "", "max-width": "500" },
          model: {
            value: _vm.weightDeviationDialog,
            callback: function ($$v) {
              _vm.weightDeviationDialog = $$v
            },
            expression: "weightDeviationDialog",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "warning--text" },
                [
                  _c(VIcon, { attrs: { left: "", color: "warning" } }, [
                    _vm._v("mdi-alert"),
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$vuetify.lang.t(
                          "$vuetify.worksheet.weightDeviation.title"
                        )
                      ) +
                      " "
                  ),
                ],
                1
              ),
              _vm.weightDeviationDetails
                ? _c(
                    VCardText,
                    [
                      _c("p", { staticClass: "text-body-1 mb-3" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.worksheet.weightDeviation.message"
                              )
                            ) +
                            " "
                        ),
                      ]),
                      _c(VSimpleTable, { attrs: { dense: "" } }, [
                        _c("tbody", [
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.weightDeviation.entered"
                                  )
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.currentEntry &&
                                    _vm.currentEntry.grossWeight
                                )
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.weightDeviation.historicalAvg"
                                  )
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.weightDeviationDetails.mean) +
                                  " ± " +
                                  _vm._s(_vm.weightDeviationDetails.stddev)
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.weightDeviation.deviation"
                                  )
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(
                                  _vm.weightDeviationDetails.deviationPct
                                ) +
                                  "% (" +
                                  _vm._s(
                                    _vm.weightDeviationDetails.deviationStddev
                                  ) +
                                  "σ)"
                              ),
                            ]),
                          ]),
                          _c("tr", [
                            _c("td", { staticClass: "font-weight-medium" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$vuetify.lang.t(
                                    "$vuetify.worksheet.weightDeviation.sampleSize"
                                  )
                                )
                              ),
                            ]),
                            _c("td", [
                              _vm._v(
                                _vm._s(_vm.weightDeviationDetails.sampleSize)
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                      _c("p", { staticClass: "text-caption mt-3 mb-0" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$vuetify.lang.t(
                                "$vuetify.worksheet.weightDeviation.action"
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                VCardActions,
                [
                  _c(VSpacer),
                  _c(
                    VBtn,
                    {
                      attrs: { text: "" },
                      on: { click: _vm.cancelWeightDeviation },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.worksheet.weightDeviation.reEnter"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    VBtn,
                    {
                      attrs: { color: "warning", loading: _vm.loading },
                      on: { click: _vm.confirmWeightDeviation },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$vuetify.lang.t(
                              "$vuetify.worksheet.weightDeviation.confirm"
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VBottomSheet,
        {
          attrs: { scrollable: "" },
          model: {
            value: _vm.showInventoryDetails,
            callback: function ($$v) {
              _vm.showInventoryDetails = $$v
            },
            expression: "showInventoryDetails",
          },
        },
        [
          _c(
            VCard,
            [
              _c(
                VCardTitle,
                { staticClass: "justify-center" },
                [
                  _c(
                    VBtn,
                    {
                      staticClass: "mt-6",
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.showInventoryDetails = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(this.$vuetify.lang.t("$vuetify.close")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(VCardText, [
                _vm.selectedInventory
                  ? _c(
                      "div",
                      [
                        _c(VDivider),
                        _vm.selectedInventoryUnit
                          ? _c("div", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-space-around text-subtitle-2",
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        this.$vuetify.lang.t(
                                          "$vuetify.worksheet.selectedUnit"
                                        )
                                      ) + ":"
                                    ),
                                  ]),
                                  _c(
                                    "div",
                                    { staticClass: "d-flex" },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.selectedInventoryUnit.code)
                                        ),
                                      ]),
                                      _c(VDivider, {
                                        staticClass: "mx-2",
                                        attrs: { vertical: "" },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("formatNumber")(
                                              _vm.selectedInventoryUnit
                                                .amountPerUnit
                                            )
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.selectedInventoryUnit
                                                .unitMeasure
                                            )
                                        ),
                                      ]),
                                      _c(VDivider, {
                                        staticClass: "mx-2",
                                        attrs: { vertical: "" },
                                      }),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.selectedInventoryUnit.unitShare
                                          ) +
                                            " " +
                                            _vm._s(
                                              _vm.productInfo
                                                ? _vm.productInfo.measureUnit
                                                : ""
                                            )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _c("inventory-details", {
                          key: _vm.selectedInventory
                            ? _vm.selectedInventory.id
                            : 0,
                          model: {
                            value: _vm.selectedInventory,
                            callback: function ($$v) {
                              _vm.selectedInventory = $$v
                            },
                            expression: "selectedInventory",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VDialog,
        {
          attrs: { "max-width": "460" },
          model: {
            value: _vm.showLmeChoice,
            callback: function ($$v) {
              _vm.showLmeChoice = $$v
            },
            expression: "showLmeChoice",
          },
        },
        [
          _c(
            VCard,
            [
              _c(VCardTitle, { staticClass: "text-subtitle-1" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.$vuetify.lang.t("$vuetify.worksheet.chooseScannedLot")
                    ) +
                    " "
                ),
              ]),
              _c(
                VList,
                { attrs: { dense: "" } },
                _vm._l(_vm.lmeMatches, function (m, i) {
                  return _c(
                    VListItem,
                    {
                      key: i,
                      on: {
                        click: function ($event) {
                          return _vm.chooseLmeMatch(m)
                        },
                      },
                    },
                    [
                      _c(
                        VListItemContent,
                        [
                          _c(VListItemTitle, [
                            _vm._v(_vm._s(m.unitDetail.code)),
                          ]),
                          _c(VListItemSubtitle, [
                            _vm._v(
                              " #" +
                                _vm._s(m.inventory.id) +
                                " · " +
                                _vm._s(m.inventory.documentNumber) +
                                " "
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VOverlay,
        { attrs: { value: _vm.ocrLoading, opacity: "0.85", "z-index": "999" } },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-column align-center",
              staticStyle: { "max-width": "320px" },
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    position: "relative",
                    width: "280px",
                    height: "210px",
                    "border-radius": "8px",
                    overflow: "hidden",
                  },
                },
                [
                  _vm.ocrPreviewUrl
                    ? _c(VImg, {
                        attrs: {
                          width: "280",
                          height: "210",
                          cover: "",
                          src: _vm.ocrPreviewUrl,
                        },
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "scan-line" }),
                  _c("div", {
                    staticStyle: {
                      position: "absolute",
                      inset: "0",
                      border: "2px solid rgba(33,150,243,0.6)",
                      "border-radius": "8px",
                      "pointer-events": "none",
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "mt-4 text-center white--text" },
                [
                  _c(VProgressCircular, {
                    staticClass: "mr-2",
                    attrs: {
                      indeterminate: "",
                      size: "24",
                      width: "2",
                      color: "white",
                    },
                  }),
                  _c("span", { staticClass: "text-subtitle-1" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$vuetify.lang.t("$vuetify.worksheet.readingScale")
                      )
                    ),
                  ]),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }